import React from 'react';
import { Field as FormikField, useField } from 'formik';
import { ClientError, FormField } from '../../../types/general';
import * as FieldsProps from '../../../types/fields';
import { errorMessage } from '../../Form/Field';

export type Props = FormField;

/**
 * Generic input type
 */
const TextArea: React.FC<Props> = (props) => {
	const { schema } = props;
	const { name, props: fieldProps } = schema;
	const { readonly, disabled, maxLength } = (fieldProps as FieldsProps.Input) || {};
	const [field, meta, helpers] = useField(name);

	return (
		<div key={`field-${name}`} className='Field-textarea'>
			<FormikField
				className={`form-control ${meta.error && meta.touched ? 'is-invalid' : ''}`}
				as='textarea'
				name={name}
				readOnly={readonly}
				disabled={disabled}
				maxLength={maxLength}
			/>
			{meta.error && meta.touched && (
				<div className='invalid-feedback'>{errorMessage(name, meta.error as unknown as ClientError[])}</div>
			)}
		</div>
	);
};

export default TextArea;
